import { dateToday, stringToDate } from 'helpers/date';

const getDiffYears = date => {
  const today = dateToday().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const dateNormalized = stringToDate(date);
  return today.diff(dateNormalized, 'years');
};

const validateClientAge = (operator, birthDate, ageThreshold) => {
  if (operator === 'ge') {
    const today = dateToday().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const birthDateNormalized = stringToDate(birthDate);
    const ages = today.diff(birthDateNormalized, 'years');
    if (ages >= parseInt(ageThreshold, 10)) {
      return true;
    }
    return false;
  }

  if (operator === 'le') {
    const today = dateToday().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const birthDateNormalized = stringToDate(birthDate);
    const ages = today.diff(birthDateNormalized, 'years');
    if (ages <= parseInt(ageThreshold, 10)) {
      return true;
    }
    return false;
  }

  if (operator === 'between') {
    const ages = getDiffYears(birthDate);
    if (ageThreshold.length !== 2)
      throw new Error(
        'El validador de fecha "between" debe tener 2 parámetros. min, max. Ejemplo: client_age_between:22,70'
      );

    const [min, max] = ageThreshold;
    return ages >= parseInt(min, 10) && ages < parseInt(max, 10);
  }
};

export { validateClientAge as default };
